<script lang="ts" setup>
import type { ProductInformation } from "@/types";

const { blok, price, type, use, isSpecsTab } = defineProps<{
  blok: ProductInformation;
  price: string;
  type: string;
  use: string;
  isSpecsTab: boolean;
}>();

const productPrice = useProductPriceName(price);

const specs = computed(() => {
  if (!isSpecsTab) {
    return [];
  }

  return [
    { title: "Slab size", value: blok.slabSize },
    { title: "Silica content", value: blok.silicaContent },
    { title: "Slab thickness", value: blok.slabThickness },
    { title: "Price range", value: productPrice },
    { title: "Slab weight", value: blok.slabWeight },
    { title: "Product type", value: type },
    { title: "Surface finish", value: blok.surfaceFinish },
    { title: "Product use", value: use },
  ].filter(({ value }) => !!value);
});
</script>

<template>
  <div v-editable="blok" class="flex flex-col gap-2.5">
    <div
      v-if="specs.length > 0"
      class="grid grid-cols-1 gap-y-2.5 md:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2 xl:gap-x-2.5 pb-5"
    >
      <div v-for="spec in specs" :key="spec.title">
        <span class="font-helvetica-bold">{{ spec.title }}</span
        >&nbsp;
        <span>{{ spec.value }}</span>
      </div>
    </div>

    <p>{{ blok.text }}</p>

    <div
      class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2 md:gap-x-2.5"
    >
      <BlokLink
        v-for="button in blok.buttons"
        :key="button._uid"
        :blok="button.url"
        :is-form="button.isForm"
        class="flex font-helvetica-bold gap-6 py-2.5 lg:py-5"
      >
        {{ button.text }}
        <NuxtImg
          width="24px"
          height="24px"
          src="/icon/chevron-right-rounded.svg"
          alt="Chevron right"
        />
      </BlokLink>
    </div>
  </div>
</template>
